import React from 'react';
import './genres.css';

export default class Genres extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
			limit: this.props.limit || 100000000,
		};
  };

	async componentDidMount() {
	}

	componentWillUnmount() {
	}

	render() {

		let genres = [];
		if( this.props.genres ) {
			genres = this.props.genres;
			if( !Array.isArray(genres) ) {
				if( this.props.genres.length > 0 ) {
					genres = genres.split(',');
				} else {
					genres = [];
				}
			}
		}

		return (
			<div className="genres">
				{(genres && genres.length > 0 ) &&
					Object.keys(genres).map((f,j) => {
						if( j < this.state.limit ) {
							return (
								<span key={j} className="genres-each" style={{marginTop:this.props.marginTop?this.props.marginTop:0, fontSize: this.props.fontSize&&this.props.fontSize}}>#{genres[f]}</span>
							)
						}
					})
				}
			</div>
		)
	}
}

